import React from 'react';
import { useQuizProfileService } from '../services/quiz-profile-service';

export const useQuizProfileController = () => {
  const {
    listProfileSteps,
    createQuizProfile,
    listProfileStepsByOrder,
    updateQuizProfileQuestion,
    listProfileStepsByIdInterview,
    addAnswersToQuizProfile,
    finishQuizService,
    sendEmail,
    sendQuizLote,
  } = useQuizProfileService();

  const [loading, setLoading] = React.useState(false);

  const getQuizProfileSteps = React.useCallback(
    (type) => {
      setLoading(true);
      return listProfileSteps(type)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [listProfileSteps],
  );

  const postQuizProfile = React.useCallback(
    (data) => {
      setLoading(true);
      return createQuizProfile(data)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [createQuizProfile],
  );

  const postAnswerToQuizProfile = React.useCallback(
    (idQuiz, params) => {
      setLoading(true);
      return addAnswersToQuizProfile(idQuiz, params)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [addAnswersToQuizProfile],
  );

  const getProfileStepByOrder = React.useCallback(
    ({ idQuiz, order }) => {
      setLoading(true);
      return listProfileStepsByOrder({ idQuiz, order })
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [listProfileStepsByOrder],
  );

  const getProfileStepByIdInterview = React.useCallback(
    (idInterview) => {
      setLoading(true);
      return listProfileStepsByIdInterview(idInterview)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [listProfileStepsByIdInterview],
  );

  const putProfileStepByAnswer = React.useCallback(
    (id, params) => {
      setLoading(true);
      return updateQuizProfileQuestion(id, params)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [updateQuizProfileQuestion],
  );

  const finishQuiz = React.useCallback(
    (idQuiz) => {
      setLoading(true);
      return finishQuizService(idQuiz)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [finishQuizService],
  );

  const sendEmailQuiz = React.useCallback(
    (idInterview) => {
      setLoading(true);
      return sendEmail(idInterview)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [sendEmail],
  );

  const sendAutoAvaliationInLote = React.useCallback(
    (ids) => {
      setLoading(true);
      return sendQuizLote(ids)
        .then((data) => {
          console.log('E-mail de autoavaliação enviado com sucesso!', data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => setLoading(false));
    },
    [sendQuizLote],
  );

  return {
    getQuizProfileSteps,
    postQuizProfile,
    loading,
    setLoading,
    getProfileStepByOrder,
    putProfileStepByAnswer,
    getProfileStepByIdInterview,
    postAnswerToQuizProfile,
    finishQuiz,
    sendEmailQuiz,
    sendAutoAvaliationInLote,
  };
};
